<template>
  <div>
    <div v-if="isLoading" class="text-center">
      <i class="fa fa-spinner fa-spin" />
    </div>
    <div v-else-if="location">
      <h4>{{ $consts.NODE_LABELS_FOR_PATH_TYPE[nodeType] || 'Nodes' }} for {{location.title}}</h4>
      <div class="my-3 input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="filter">
            <i class="fa fa-search"></i>
          </span>
        </div>
        <input
          v-model.trim="filter"
          class="form-control"
          aria-describedby="filter"
          placeholder="filter by name"
        />
      </div>
      <div v-if="filteredNodes.length < 1">No nodes found for this criteria.</div>
      <span v-for="(node, i) in filteredNodes" :key="i + 'node'">
        <button
          @click="onSelect(node)"
          class="node-link btn w-100"
          :class="selected === node ? 'btn-primary' : 'btn-outline-primary'"
        >{{node.title}}</button>
      </span>
    </div>
    <error-panel class="m-auto" :errors="errors"></error-panel>
  </div>
</template>

<script>
export default {
  name: "node-grid",
  props: ["location", "isLoading"],
  data: () => ({
    loading: true,
    errors: [],
    selected: null,
    filter: ""
  }),
  computed: {
    nodeType() {
      return this.$route.params.nodeType;
    },
    intNodeType() {
      return this.$consts.NODE_TYPE_STR_TO_INT[this.nodeType];
    },
    filteredNodes() {
      if (!this.location) return [];

      return this.location.nodes[this.intNodeType].filter(node =>
        node.title.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },
  methods: {
    onSelect(node) {
      // Push to panels page
      this.$router.push(
        `/nodes/${this.$route.params.locationId}/${this.$route.params.nodeType}/${node.id}`
      );
    }
  },
  mounted() {}
};
</script>

<style scoped>
.logo {
  max-width: 100%;
  max-height: 100%;
}

.node-link {
  margin-top: 0.5rem;
}
</style>
